// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"c3398cac","168":"60d7b470"}[chunkId] + ".chunk.css";
};